import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    SubscriptionTypeService,
    SubscriptionTypePopupService,
    SubscriptionTypeComponent,
    SubscriptionTypeDetailComponent,
    SubscriptionTypeDialogComponent,
    SubscriptionTypePopupComponent,
    SubscriptionTypeDeletePopupComponent,
    SubscriptionTypeDeleteDialogComponent,
    subscriptionTypeRoute,
    subscriptionTypePopupRoute,
    SubscriptionTypeResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...subscriptionTypeRoute,
    ...subscriptionTypePopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        SubscriptionTypeComponent,
        SubscriptionTypeDetailComponent,
        SubscriptionTypeDialogComponent,
        SubscriptionTypeDeleteDialogComponent,
        SubscriptionTypePopupComponent,
        SubscriptionTypeDeletePopupComponent,
    ],
    entryComponents: [
        SubscriptionTypeComponent,
        SubscriptionTypeDialogComponent,
        SubscriptionTypePopupComponent,
        SubscriptionTypeDeleteDialogComponent,
        SubscriptionTypeDeletePopupComponent,
    ],
    providers: [
        SubscriptionTypeService,
        SubscriptionTypePopupService,
        SubscriptionTypeResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiSubscriptionTypeModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/subscription-type/subscription-type.module.ts